import React, { useEffect } from 'react';
import { CardListFilterState } from './types';
import CardsList from './cards/cardsList';
import FilterContainer from './filter/index';
import { setInitData, setLoadingState } from './filterListSlice';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';

interface ContainerProps {
  blockId: number;
}

const container = ({ blockId }: ContainerProps) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(
    (state: CardListFilterState) => state.isLoading
  );
  const isProcessing = useSelector(
    (state: CardListFilterState) => state.isProcessing
  );

  useEffect(() => {
    axios
      .get(
        `/umbraco/api/toursapi/gettourcards?blockId=${blockId}&culture=${window.globalSettings.currentCulture}`
      )
      .then((result) => {
        if (result.status === 200) {
          dispatch(setInitData(result.data));
        } else {
          throw 'invalid response';
        }
      })
      .catch((error) => {
        dispatch(setLoadingState(false));
      });
  }, []);

  return isLoading ? (
    <div className='spinner' />
  ) : (
    <>
      {isProcessing && (
        <div
          className='col-12'
          style={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            zIndex: 9999,
            backgroundColor: 'black',
            opacity: 0.5,
          }}
        ></div>
      )}
      <FilterContainer />
      <CardsList />
    </>
  );
};

export default container;
